/*
  import { getV } from '@/services/ViolationIssue/Violation/Get';

  // for example:
    const { successful, message, details } = await getV ({
      id
    });
    if (!successful) {
      notifyProblem (message);
      return;
    }

*/
//
import kms from '@/services/kms'
//
export async function getV({ kms: kms_ = kms, id } = {}) {
  try {
    const details = await kms_.get(`/ViolationIssue/Violation/${id}`)

    return {
      successful: true,
      message: null,
      details
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message: `The details could not be retrieved successfully.`,
    details: null
  }
}
